module.exports = __webpack_public_path__ + "img/logoColombbus.3272e476.png";